import React, { useState, useEffect, useRef } from "react";
import "../../../operations/pages/DetailsPage/DetailsScreen.css";

const CategoryLeadPopup = ({
  isOpen,
  onClose,
  onSave,
  primaryLabel = "Primary Category",
  primaryOptions = [],
  primaryValue = "",
  onPrimaryChange,
  secondaryLabel = "Secondary Category",
  secondaryOptions = [],
  secondaryValues = [],
  onSecondaryChange,
  isSaving = false,
}) => {
  const [isSecondaryOpen, setIsSecondaryOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const normalize = (val) => val?.trim().toLowerCase();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsSecondaryOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (secondaryValues.some(val => normalize(val) === normalize(primaryValue))) {
      onSecondaryChange(
        secondaryValues.filter(val => normalize(val) !== normalize(primaryValue))
      );
    }
  }, [primaryValue]);

  if (!isOpen) return null;

const filteredSecondaryOptions = secondaryOptions
  .filter((opt) => normalize(opt) !== normalize(primaryValue)) // ✅ FIXED
  .filter((opt) => normalize(opt) !== normalize("Short Disrupted Calls"))
  .filter((opt) =>
    opt.toLowerCase().includes(searchTerm.toLowerCase())
  );

  

const handleSecondaryToggle = (option) => {
  if (!option || option.trim() === "") return; // ✅ prevent empty

 if (normalize(option) === normalize(primaryValue)) return;

  if (secondaryValues.some(v => normalize(v) === normalize(option))) {
    onSecondaryChange(secondaryValues.filter((v) => normalize(v) !== normalize(option)));
  } else {
    onSecondaryChange([...secondaryValues, option]);
  }
};




  const dropdownStyle = {
    width: "100%",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "10px 12px",
    background: "#fff",
    outline: "none",
    fontSize: "14px",
    color: "#333",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "border-color 0.2s",
  };



  return (
    <div className="feedback-overlay">
      <div className="feedback-popup-content" style={{ maxWidth: "450px", position: "relative" }}>
        <h3 className="pop-main-title">Edit Category Lead</h3>
        <p className="feedback-instruction-text">
          Select the primary classification and corresponding secondary categories.
        </p>

        {/* ---- Primary Field ---- */}
        <div className="observation-input-container">
          <label className="obs-label-text">{primaryLabel}</label>
          <div style={{ position: "relative" }}>
            <select
              value={primaryValue}
              onChange={(e) => onPrimaryChange(e.target.value)}
              style={{ ...dropdownStyle, appearance: "none" }}
            >
              <option value="">-- Select Primary Category --</option>
              {primaryValue &&
                !primaryOptions.some(
                  (opt) => normalize(opt) === normalize(primaryValue),
                ) && (
                  <option value={primaryValue}>{primaryValue}</option>
                )}
              {primaryOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
            <span style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: "#666", fontSize: "10px" }}>▼</span>
          </div>
        </div>

        {/* ---- Secondary Field (Multi-Select) ---- */}
        <div className="observation-input-container" style={{ marginTop: "18px", position: "relative" }} ref={dropdownRef}>
          <label className="obs-label-text">{secondaryLabel}</label>
          
          <div 
            onClick={() => setIsSecondaryOpen(!isSecondaryOpen)}
            style={{ ...dropdownStyle, borderColor: isSecondaryOpen ? "#1b456b" : "#e0e0e0" }}
          >
            <span style={{ color: secondaryValues.length ? "#333" : "#999", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "90%" }}>
              {secondaryValues.length 
                ? `${secondaryValues.length} Categories Selected` 
                : "-- Select Secondary Categories --"}
            </span>
            <span style={{ color: "#666", fontSize: "10px", transform: isSecondaryOpen ? "rotate(180deg)" : "none", transition: "0.2s" }}>▼</span>
          </div>

          {isSecondaryOpen && (
            <div style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              backgroundColor: "#fff",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              marginTop: "4px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
              zIndex: 100,
              overflow: "hidden"
            }}>
              {/* Search Input inside Dropdown */}
              <input 
                type="text"
                placeholder="Search categories..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "none",
                  borderBottom: "1px solid #eee",
                  outline: "none",
                  fontSize: "13px"
                }}
              />
              
              <div style={{ maxHeight: "180px", overflowY: "auto" }}>
                {filteredSecondaryOptions.length > 0 ? (
                  filteredSecondaryOptions.map((opt) => {
                    const isSelected = secondaryValues.some(v => normalize(v) === normalize(opt));
                    return (
                      <div
                        key={opt}
                        onClick={() => handleSecondaryToggle(opt)}
                        style={{
                          padding: "10px 14px",
                          fontSize: "13px",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          backgroundColor: isSelected ? "#f4f8fb" : "transparent",
                          color: isSelected ? "#1b456b" : "#444",
                          fontWeight: isSelected ? "600" : "400"
                        }}
                      >
                        {opt}
                        {isSelected && <span style={{ color: "#1b456b", fontSize: "12px" }}>✓</span>}
                      </div>
                    );
                  })
                ) : (
                  <div style={{ padding: "15px", textAlign: "center", color: "#999", fontSize: "12px" }}>No results found</div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* ---- Selected Tags Preview ---- */}
        <div style={{ minHeight: "40px", marginTop: "12px" }}>
          {secondaryValues.length > 0 && (
            <div style={{
              padding: "10px",
              backgroundColor: "#f9f9f9",
              borderRadius: "8px",
              border: "1px dashed #dcdcdc"
            }}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {secondaryValues.map(val => (
                  <div key={val} style={{
                    fontSize: "11px",
                    backgroundColor: "#1b456b",
                    padding: "4px 10px",
                    borderRadius: "15px",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  }}>
                    {val}
                    <span 
                      onClick={() => handleSecondaryToggle(val)}
                      style={{ cursor: "pointer", opacity: 0.8, fontSize: "14px", fontWeight: "bold" }}
                    >
                      ×
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* ---- Footer ---- */}
        <div className="feedback-footer" style={{ borderTop: "1px solid #eee", paddingTop: "20px", marginTop: "10px" }}>
          <span className="feedback-cancel-text" onClick={onClose} style={{ cursor: "pointer" }}>
            Cancel
          </span>
          <button
            className="feedback-submit-btn"
            onClick={onSave}
            disabled={isSaving || !primaryValue}
            style={{ 
              backgroundColor: isSaving || !primaryValue ? "#ccc" : "#1b456b",
              padding: "10px 25px",
              transition: "0.3s"
            }}
          >
            {isSaving ? "Saving..." : "Save Selection"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryLeadPopup;